import { Nullable } from 'global';
import { RevenuePaymentTypeFilter, RevenueDealStatusFilter } from '@trnsact/trnsact-shared-types';
import { FinanceFilters, FinanceFilterType, FinanceFiltersPayload } from './types';
import { dateRangeToMoments } from 'modules/finance/sharedFilters';

export const formatFilterForFinancePayload = (filters: Nullable<Partial<FinanceFilters>>): FinanceFiltersPayload => {
  if (!filters) return {};

  const result: FinanceFiltersPayload = {};

  const dealDatePreset = filters[FinanceFilterType.DEAL_DATE];
  if (dealDatePreset) {
    const { from, to } = dateRangeToMoments(dealDatePreset);
    result.dealDate = {
      from: from.toISOString(),
      to: to.toISOString(),
    };
  }

  const salesRep = filters[FinanceFilterType.SALES_REP];
  if (salesRep?.length) {
    result.salesRep = salesRep.map(v => (v.value === 'unassigned' ? null : v.value));
  }

  const location = filters[FinanceFilterType.LOCATION];
  if (location?.length) {
    result.location = location.map(v => (v.value === 'unassigned' ? null : v.value));
  }

  const paymentType = filters[FinanceFilterType.PAYMENT_TYPE];
  if (paymentType && paymentType !== RevenuePaymentTypeFilter.All) {
    result.paymentType = paymentType;
  }

  const dealStatus = filters[FinanceFilterType.DEAL_STATUS];
  if (dealStatus && dealStatus !== 'ALL') {
    result.dealStatus = dealStatus as RevenueDealStatusFilter;
  }

  return result;
};

export const calcFinanceFiltersAmount = (filters: Nullable<Partial<FinanceFilters>>) => {
  if (!filters) return 0;

  return Object.entries(filters).reduce<number>((amount, [key, value]) => {
    if (key === FinanceFilterType.DEAL_DATE) return amount;

    if (Array.isArray(value)) return (amount += value.length);

    if (typeof value === 'string' && value && value !== RevenuePaymentTypeFilter.All) {
      return (amount += 1);
    }

    if (typeof value === 'object' && value !== null) {
      return (amount += Object.values(value).filter(Boolean).length);
    }

    if (typeof value === 'boolean' && value) {
      return (amount += 1);
    }

    return amount;
  }, 0);
};
